<template>
  <CSidebar
      :class="sidebarClasses"
      color-scheme="light"
      fixed
      :minimize="minimize"
      :show="show"
      @update:show="(value) => $store.commit('set', ['sidebarShow', value])"
  >
    <CSidebarBrand class="d-md-down-none" to="/">
      <div class="d-flex flex-row align-items-center">
        <CIcon
            class="c-sidebar-brand-full"
            name="logo"
            size="custom-size"
            :height="32"
            viewBox="0 0 136 34"
        />
      </div>
    </CSidebarBrand>

    <slot name="header-nav"/>
    <slot>
      <CSidebarNav>
        <Events/>
        <CustomerSuccess/>
        <PhotoService/>
        <Administration/>
        <PermissionManagement/>
        <Configuration/>
        <Reports/>
        <Payments/>
      </CSidebarNav>
    </slot>
  </CSidebar>
</template>

<script>
import sidebar from "@coreui/coreui/js/src/sidebar";
import {mapGetters} from "vuex";
import Events from "./nav/Events.vue";
import Administration from "./nav/Administration";
import PermissionManagement from "./nav/PermissionManagement";
import Configuration from "./nav/Configuration";
import CustomerSuccess from "./nav/CustomerSuccess";
import Payments from "./nav/Payments";
import PhotoService from "./nav/PhotoService";
import Reports from "./nav/Reports";
import CreateNewEventModal from "@/domain/events/components/CreateNewEventModal.vue";

export default {
  name: 'TheSidebar',

  components: {
    Events,
    Administration,
    PermissionManagement,
    Configuration,
    CustomerSuccess,
    Payments,
    PhotoService,
    Reports
  },

  computed: {
    ...mapGetters('event', [
      'isInEvent',
    ]),
    sidebar() {
      return sidebar
    },
    show() {
      return this.$store.state.sidebarShow
    },
    minimize() {
      return this.$store.state.sidebarMinimize
    },

    sidebarClasses() {
      let suffix = 'index'
      if (this.isInEvent) {
        suffix = 'in-event'
      }
      return [`sidebar--${suffix}`]
    }
  }
}
</script>
